import logger from '@/utils/logger'

import SHWError from './SHWError'

export default function transformToSHWError(error: Error): SHWError {
  if (error instanceof SHWError) {
    return error
  }

  logger.error('Transforming unexpected error to SHW error', { internalError: error })
  return new SHWError({ internalMessage: error.message })
}
